import script from "./BusinessApplicationsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BusinessApplicationsPage.vue?vue&type=script&setup=true&lang=js"

import "./BusinessApplicationsPage.vue?vue&type=style&index=0&id=58a1454a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58a1454a"]])

export default __exports__